import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { TaskCanceled } from "abweb/service/rpc/TaskCanceled";
export class ViewSubscription {
  constructor(task) {
    _defineProperty(this, "task", void 0);
    _defineProperty(this, "cancelableTaskResult", void 0);
    this.task = task;
    this.cancelableTaskResult = this.task.result().catch(e => {
      if (ClassUtils.isInstanceOf(e, TaskCanceled)) {
        //TODO: add an onUnsubscribe hook
        return undefined;
      }
      throw e;
    });
  }
  get taskId() {
    return this.task.taskId;
  }
  view() {
    return this.cancelableTaskResult;
  }
  unsubscribe() {
    return this.task.cancel();
  }
}
//# sourceMappingURL=ViewSubscription.js.map
